module.exports = __webpack_public_path__ + "static/img/df_game.9f29239.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img_grande/df_game.png
// module id = xjkL
// module chunks = 1